var MM = MM || {}

MM.utility = {
};


MM.var = {
  $body: $('body'),
  $window: $(window),
};


/**
 * bodyのスクロールを停止する
 */
MM.bodyFix = {
  position: false,
  set: function() {
    this.position = MM.var.$window.scrollTop();
    // console.log(this.position);
    MM.var.$body
    .addClass('BODY_FIXED')
    .css({
      position: 'fixed',
      width: '100%',
      height: '100%',
      overflowX: 'hidden',
      overflowY: 'scroll',
      top: Math.abs(this.position) * -1
    });
  },
  unset: function() {
    if(this.position === false) return false;
    MM.var.$body
    .removeClass('BODY_FIXED')
    .css({
      position: '',
      width: '',
      height: '',
      overflowX: '',
      overflowY: '',
      top: ''
    });

    MM.var.$window.scrollTop(Math.abs(this.position));
    this.position = false;
  },
};


/**
 * ナビゲーションメニューの開閉
 */
MM.navigation = {
  fn: function() {
    this.view = false;
    this.animation = false;
    this.$navigation = $('#l_navigation');
    this.$btn = $('.js_navigation_btn');
    this.$btn.on('click', () => {
      if(this.animation) return false;
      this.toggle();
    });
  },
  open: function() {
    // console.log('open');
    if(this.animation) return false;
    MM.bodyFix.set();
    this.$btn.addClass('is_active');
    this.view = true;
    this.animation = true;
    this.$navigation.velocity('fadeIn', {duration: 300, complete: () => { this.animation = false; }});
  },
  close: function() {
    // console.log('close');
    MM.bodyFix.unset();
    if(this.animation) return false;
    this.$btn.removeClass('is_active');
    this.animation = true;
    this.$navigation.velocity('fadeOut', {duration: 300, complete: () => { this.animation = false; this.view = false }});
  },
  toggle: function() {
    if(this.animation) return false;
    if(this.view) {
      this.close();
    } else {
      this.open();
    }
  },
  clear: function() {
    this.animation = false;
    this.view = false;
    this.$navigation.hide();
    this.$btn.removeClass('is_active');
  }
};


/**
 * メニューアコーディオンの開閉
 */
MM.menuAchordion = {
  fn: function() {
    let self = this;
    this.$btn = $('.js_footer_achordion');
    this.$btn.on('click', function() {
      if(window.innerWidth > 640 || $(this).hasClass('is_animation')) return false;
      self.toggle($(this));
    });
  },
  open: function($object) {
    $object.addClass('is_animation is_active');
    $object.next().velocity('slideDown', { duration: 300, complete: function() { $object.removeClass('is_animation') }});
  },
  close: function($object) {
    $object.addClass('is_animation').removeClass('is_active');
    $object.next().velocity('slideUp', { duration: 300, complete: function() { $object.removeClass('is_animation') }});
  },
  toggle: function($object) {
    if($object.hasClass('is_active')) {
      this.close($object);
    } else {
      this.open($object);
    }
  },
  clear: function() {
    this.$btn.next().css({
      display: ''
    });
    this.$btn.each(function() {
      if($(this).hasClass('is_current')) {
        $(this).removeClass('is_animation').addClass('is_active');
      } else {
        $(this).removeClass('is_animation is_active');
      }
    });
  }
}


/**
 * ロケーション選択
 */
MM.localAchordion = {
  fn: function() {
    let self = this;
    this.animation = false;
    this.$btn = $('.js_local_btn');

    this.$btn.on('click', function() {
      self.toggle($(this));
    });
  },

  open: function($object) {
    let self = this;
    if($object.hasClass('is_animation')) return false;
    $object.addClass('is_active is_animation');

    $object.next().velocity('slideDown', { duration: 300, complete: () => {
      $object.removeClass('is_animation')

      // bodyに閉じるイベントを登録する
      MM.var.$body.on('click.local', function(e){
        if(!$(e.target).closest('.js_local_body').length) {
          self.close($object);
        }
      })
    }})
  },

  close: function($object) {
    if($object.hasClass('is_animation')) return false;
    $object.addClass('is_animation');

    $object.next().velocity('slideUp', { duration: 300, complete: () => { $object.removeClass('is_active is_animation') }})

    MM.var.$body.off('click.local');

  },



  toggle: function($object) {
    if($object.hasClass('is_active')) {
      this.close($object);
    } else {
      this.open($object);
    }
  },

  clear: function() {

  }
};



/**
 * matchMedia判定
 */
MM.mediaQuery = {
  fn: function() {
    // メディア設定
    window.matchMedia('screen and (max-width:640px)').addListener( function(e) {
      MM.menuAchordion.clear();
      MM.navigation.clear();
      MM.bodyFix.unset();

      if(!e.matches) {
      } else {
      }
    });
  }
};



/**
 * 中国系SNSボタンの設定
 */
MM.chineseSns = {
  fn: function() {
    let self = this;

    var share_url   = document.URL;
    var share_title = document.title;

    // LINEボタンのURL動的生成
    var btn = document.getElementById('sns-line');
    if(!btn) { return };
    btn.href = 'https://social-plugins.line.me/lineit/share?url=' + encodeURI(location.href);

    // TwitterボタンのURL動的生成
    var btn = document.getElementById('sns-twitter');
    btn.href = '//twitter.com/share?url=' + encodeURI(location.href) + '&amp;text=' + encodeURI(share_title);

    // 中国系SNSの処理
    $('.js_social_link').each(function(idx) {
      var $link = $(this);
      var social_type = $link.data('social-type');

      var $box = false;
      if (social_type == 'wechat') {
        var _init_func = self['init_' + social_type];
        if (typeof(_init_func) == 'function') {
          $box = _init_func($link, share_url, share_title);
        }
      }

      $link.on('click', function() {
        var _func = self[social_type];
        if (typeof(_func) == 'function') {
          _func(share_url, share_title, $box);

          return false;
        }
      });
    });
  },

  weibo: function(share_url, share_title) {
    var options = ['width=650','height=500','location=yes','resizable=yes','toolbar=no','menubar=no','scrollbars=no','status=no'];
    var _share_url = 'http://service.weibo.com/share/share.php?';
    _share_url += 'title=' + encodeURIComponent(share_title);
    _share_url += '&url=' + encodeURIComponent(share_url);
    _share_url += '&description=' + '';

    var _option = options.join(',');
    window.open(_share_url, 'share', _option);

    return false;
  },

  init_wechat: function($target, share_url, share_title) {
    var panel_code = '<div class="l_wechat_panel">';
    panel_code += '<p class="l_wechat_panel_title">分享到微信朋友圈</p>';
    panel_code += '<p class="l_wechat_panel_close"></p>';
    panel_code += '<div class="l_wechat_panel_qrcode"><p class="js_qrcode_wechat"></p></div>';
    panel_code += '<p class="l_wechat_panel_text">打开微信，点击底部的“发现”，<br>使用“扫一扫”即可将网页分享至朋友圈。</p>';
    panel_code += '</div>';

    var $panel = $(panel_code);
    var $panel_qr = $panel.find('.js_qrcode_wechat');
    $target.after($panel);
    $panel.hide();

    $panel_qr.qrcode({width: 185, height: 185, text: share_url});

    $panel.on('click', function() {
      MM.chineseSns.wechat(share_url, share_title, $panel);
    })

    return $panel;
  },

  wechat: function(share_url, share_title, $target) {
    if ($target.hasClass('is_show')) {
      $target.hide();
      $target.removeClass('is_show');
    } else {
      $target.show();
      $target.addClass('is_show');
    }
  }
};


/**
 * ページトップ
 */
MM.pageTop = {
  fn: function() {
    this.$btn = $('#l_pagetop_btn');
    this.$btn.on('click', function() {
      $('body').velocity('scroll', {duration: 500});
    });
  }
};


/**
 * スクロール量に応じてbodyにクラスを付与
 */
MM.contentsView = {
  fn: function() {
    MM.var.$window.on('scroll', $.throttle(30, function(){
      if(MM.var.$window.scrollTop() > 400) {
        MM.var.$body.addClass('VIEW_CONTENTS');
      } else {
        MM.var.$body.removeClass('VIEW_CONTENTS');
      }
    }));
  }
};



/**
 * アンカーのスムーススクロール
 */
MM.smoothScroll = {
  fn: function() {
    this.$btn = $('a[href^="#"]');
    this.$btn.on('click', function(e) {
      e.preventDefault;
      let href = $(this).attr('href');
      if(href !== '#') {
        $(href).velocity('scroll', {duration: 300, offset: -80});
      }
      return false;
    });
  }
};




/**
 * 海外エリアのモーダル制御
 */
MM.overseas = {
  fn: function() {
    let self = this;
    this.animation = false;
    this.view = false;
    this.$btn = $('.js_overseas_btn');
    this.$modal = $('#l_overseas_modal');
    this.$area = $('#l_overseas_modal').find('.js_overseas_modal_area');
    this.$close = $('#l_overseas_modal').find('.js_overseas_modal_close');

    this.$btn.on('click', function(){
      let local = $(this).data('location');
      self.area(local);
      self.open();
    });

    this.$close.on('click', function(){
      self.close();
    });
  },

  area: function(local) {
    this.$area.hide().filter(function(i){
      return $(this).data('location') === local;
    }).show();
  },

  open: function() {
    if(this.animation) return false;
    let self = this;
    this.animation = true;
    this.$modal.velocity('fadeIn', { duration: 300, complete: () => { this.animation = false }})

    MM.var.$body.on('click.overseas', function(event) {
      if (!$(event.target).closest('.l_overseas_modal_contents').length) {
        self.close();
      }
    });
  },

  close: function() {
    if(this.animation) return false;
    this.animation = true;
    this.$modal.velocity('fadeOut', { duration: 300, complete: () => { this.animation = false }})
    MM.var.$body.off('click.overseas');
  }
};



/**
 * IDで指定されたボタンとコンテンツを対とするアコーディオン（旧common輸入）
 */
MM.idAchordion = {
  fn: function() {
    $("#js_accordion_btn").on('click', function(){
      $(this).toggleClass('is_active');
      $("#js_accordion").slideToggle();
    });
  }
};



/**
 * Add 2017.2.1 GAトラッキング
 * 実行する場合は、ページ内で以下のメソッド
 * ※ 関数cloneApplyBtn内にも、トラッキング用の追加処理あり
 */
MM.ga = {
 fn: function(){
   $('body').on('click' , '.js_GA_conversion' ,function(){
     var $this = $(this);

     var ga_category = $this.data('ga-category');
     var ga_event    = $this.data('ga-event');
     var ga_label    = $this.data('ga-label');

     window.dataLayer = window.dataLayer || [];
     dataLayer.push({
       'event' : 'trackEvent',
       'ga_event_category' : ga_category,
       'ga_event_action' : ga_event,
       'ga_event_label' : ga_label
     });
   });
 }
}

/**
 * ロケーションクッキー制御
 */
MM.location = {
  fn: function(){
    var $location = $('.js-country');

    $('.js-country').on('change',function(){
      var _Count = $(this).prop("selectedIndex");
      var _url = $(this).val();
      var _lang = $(this).children().eq(_Count).data('lang');
      var _location = $(this).children().eq(_Count).data('location');


      document.cookie = 'fr_location='+_location+'; path=/employment/';
      document.cookie = 'fr_language='+_lang+'; path=/employment/';
      window.location.href = _url;
    });
  }
}




window.addEventListener('DOMContentLoaded', () => {
  MM.menuAchordion.fn();
  MM.navigation.fn();
  MM.mediaQuery.fn();
  MM.localAchordion.fn();
  MM.chineseSns.fn();
  MM.overseas.fn();
  MM.pageTop.fn();
  MM.smoothScroll.fn();
  MM.contentsView.fn();
  MM.ga.fn();
  MM.idAchordion.fn();
  MM.location.fn();
});
